import { Typography, Box, Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material'
import { ICheckbox } from './types'
import { Controller } from 'react-hook-form'

const Checkbox: React.FC<ICheckbox> = ({
  label = '',
  control,
  fieldName,
  value,
  previewOnly = false,
}) => {
  // console.log(fieldName, previewOnly)
  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      {control && (
        <Controller
          render={({ field }) => (
            <FormControlLabel
              control={
                <MuiCheckbox {...field} value={value} checked={value} disabled={previewOnly} />
              }
              label={<Typography variant='bodyRegular'>{label}</Typography>}
            />
          )}
          name={fieldName}
          control={control}
          defaultValue={''}
        />
      )}
    </Box>
  )
}

export default Checkbox
